<template>
    <div class="z-10">
        <PageComponent 
            :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader"
            :addButtonLabel="addButtonLabel"
            @handleAddNew="addNewPolicy"
            :searchFilters="searchFilters"
            :dropdownOptions="dropdownOptions"
            @handleDynamicOption="handleDynamicOption"
            @searchPage="searchTimePolicies"
            @resetFilters="resetFilters"
            @removeItem="removePolicy"
            @removeSelectedItems="removePolicies"
            @printList="printList"
            :addingRight="addingRight"
            :removingRight="removingRight"
            :rightsModule="rightsModule"
            :columns="tableColumns"
            :rows="policyList"
            :actions="actions"
            :idField="idField"
            @handleSelectionChange="handleSelectionChange"
            @handleActionClick="handleActionClick"
            :count="propCount"
            :currentPage="currentPage"
            :result="propArrLen"
            @loadPrev="loadPrev"
            @loadNext="loadNext"
            @firstPage="firstPage"
            @lastPage="lastPage"
            :showNextBtn="showNextBtn"
            :showPreviousBtn="showPreviousBtn"
            :selectedValue="selectedValue"
            @selectSearchQuantity="selectSearchQuantity"
        />
        <MovableModal v-model:visible="propModalVisible" :title="title" :modal_top="modal_top" :modal_left="modal_left" :modal_width="modal_width"
            :loader="modal_loader" @showLoader="showModalLoader" @hideLoader="hideModalLoader" @closeModal="closeModal">
            <DynamicForm 
                :fields="formFields" :flex_basis="flex_basis" :flex_basis_percentage="flex_basis_percentage" 
                :displayButtons="displayButtons" @handleSubmit="saveLeave" @handleReset="handleReset"
            />
        </MovableModal>
        <MovableModal v-model:visible="holModalVisible" :title="holTitle" :modal_top="modal_top" :modal_left="modal_left" :modal_width="hol_modal_width"
            :loader="hol_modal_loader" @showLoader="showHolModalLoader" @hideLoader="hideHolModalLoader" @closeModal="closeHolModal">
            <div class="relative mb-6 mt-3 min-w-[500px]">
                <SearchableDropdown
                    :key="holComponentKey"
                    :options="payGroupArray"
                    :dropdownWidth="dropdownWidth"
                    @option-selected="handleSelectedPayGroup"
                    @clearSearch="clearSelectedPayGroup"                             
                />
            </div>
            <div class="min-h-[300px] min-w-[500px]">
                <DynamicTable :columns="grpColumns" :rows="grpRows" :idField="pgrpIdField" @selection-changed="selectionGroupChanged" :rightsModule="rightsModule" :actions="grpActions" @action-click="handleGroupsActions" />
            </div>
    </MovableModal>
    </div>
</template>

<script>
import axios from "axios";
import { ref, computed, onMounted, onBeforeMount, watch} from 'vue';
import PageComponent from '@/components/PageComponent.vue';
import MovableModal from '@/components/MovableModal.vue'
import DynamicForm from '../NewDynamicForm.vue';
import SearchableDropdown from '@/components/SearchableDropdown.vue';
import DynamicTable from '../DynamicTable.vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import Swal from 'sweetalert2';

export default{
    name: 'Time_Policy',
    components:{
        PageComponent, MovableModal,DynamicForm,SearchableDropdown,DynamicTable
    },
    setup(){
        const store = useStore();     
        const toast = useToast();
        const loader = ref('none');
        const modal_loader = ref('none');
        const hol_modal_loader = ref('none');
        const idField = 'time_policy_id';
        const pgrpIdField = 'paygrp_time_id';
        const addButtonLabel = ref('New Policy');
        const title = ref('Time Policy Details');
        const holTitle = ref('Assign Pay Group');
        const payGroupArray = computed(() => store.state.Pay_Groups.groupArr);
        const addingRight = ref('Adding Time Policies');
        const removingRight = ref('Deleting Time Policies');
        const rightsModule = ref('HR');
        const submitButtonLabel = ref('Add');
        const holComponentKey = ref(0);
        const selectedIds = ref([]);
        const selectedGroups = ref([]);
        const selectedValue = ref(50);
        const policyList = ref([]);
        const propResults = ref([]);
        const propArrLen = ref(0);
        const propCount = ref(0);
        const pageCount = ref(0);
        const currentPage = ref(1);
        const showNextBtn = ref(false);
        const showPreviousBtn = ref(false);
        const propModalVisible = ref(false);
        const holModalVisible = ref(false);
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const displayButtons = ref(true);
        const errors = ref([]);
        const dropdownWidth = ref("320px")
        const modal_top = ref('130px');
        const modal_left = ref('300px');
        const modal_width = ref('40vw');
        const hol_modal_width = ref('35vw');
        const isEditing = computed(()=> store.state.Time_Policy.isEditing);
        const selectedPolicy = computed(()=> store.state.Time_Policy.selectedPolicy);
        const showModal = ref(false);
        const tableColumns = ref([
            {type: "checkbox"},
            {label: "Name", key:"name"},
            {label: "Effective Date", key: "date"},
            {label: "Wkdy. Time", key: "weekday_time"},
            {label: "Wkdy. Hrs", key:"weekday_hours"},
            {label: "Sat. Time", key: "saturday_time"},
            {label: "Sat. Hrs", key:"saturday_hours"},
            {label: "Sun. Time", key: "sunday_time"},
            {label: "Sun. Hrs", key:"sunday_hours"},
            {label: "Overtime", key: "overtime"},
            {label: "Break(Mins)", key: "break_minutes"},
        ])
        const actions = ref([
            {name: 'edit', icon: 'fa fa-edit', title: 'Edit Policy', rightName: 'Editing Time Policies'},
            {name: 'assign-pgroup', icon: 'fa fa-tasks', title: 'Assign Pay Group', rightName: 'Editing Time Policies'},
            {name: 'delete', icon: 'fa fa-trash', title: 'Delete Policy', rightName: 'Deleting Time Policies'},
        ]);
        const grpColumns = ref([
            {type: "checkbox"},
            {label: "Pay Group", key:"pay_group_name",type: "text", editable: false},
        ]);
        const grpActions = ref([
            {name: 'add-pgroup', icon: 'fa fa-check', title: 'Add Group', rightName: 'Editing Time Policies'},
            {name: 'delete', icon: 'fa fa-trash', title: 'Delete Group', rightName: 'Editing Time Policies'},
        ]);
        const grpRows = computed(()=> store.state.Pay_Groups.timePolArray);
        const companyID = computed(()=> store.state.userData.company_id);
        const policyID = ref(null);
        const name_search = ref('');
        const searchFilters = ref([
            {type:'text', placeholder:"Name...", value: name_search, width:60,},
        ]);
        const fetchPayGroups = async() =>{
            await store.dispatch('Pay_Groups/fetchPayGroups', {company:companyID.value})
        };
        const handleSelectedPayGroup = async(option) =>{
            await store.dispatch('Pay_Groups/handleSelectedTimePolicyPayGroup', option)
            holComponentKey.value += 1;
        };
        const clearSelectedPayGroup= async() =>{
            await store.dispatch('Pay_Groups/updateState', {groupID: '', groupName: ""});
        };
        const handleSelectionChange = (ids) => {
            selectedIds.value = ids;
        };
        const selectionGroupChanged = (ids) => {
            selectedGroups.value = ids;
        };
        const showHolModalLoader = () =>{
            hol_modal_loader.value = "block";
        }
        const hideHolModalLoader = () =>{
            hol_modal_loader.value = "none";
        };
        const fetchPolicyGroups = async(policyID) =>{
            let formData = {
                time_policy: policyID,
                company: companyID.value
            }
            axios.post("api/v1/timepolicy-paygroups-search/", formData)
            .then((response)=>{
                store.dispatch('Pay_Groups/updateState', {timePolArray: response.data.pay_groups})
            })
            .catch((error)=>{
                console.log(error.message)
            })
        };
        const handleGroupsActions = (rowIndex, action, row) =>{
            if(action == "add-pgroup"){
                let formData = {
                    time_policy: policyID.value,
                    time_policy_id: policyID.value,
                    pay_group: row['pay_group_id'],
                    pay_group_id: row['pay_group_id'],
                    company: companyID.value
                }
                if(!row['leave_holiday_id']){
                    axios.post("api/v1/create-timepolicy-paygroup/", formData)
                    .then((response)=>{
                        if(response.status === 201){
                            toast.success("Pay Group Added Succesfully")
                            holComponentKey.value += 1;
                            fetchPolicyGroups(policyID.value);
                        }
                        else{
                            toast.error("Error Adding Pay Group") 
                            holComponentKey.value += 1;
                        }
                        
                    })
                    .catch((error)=>{
                        console.log(error.message);
                        toast.error(error.message) 
                    })
                }else if(row['paygrp_time_id']){
                    toast.error("Pay Group Already Added")
                }
                
            }else if(action == "delete"){
                Swal.fire({
                title: "Are you sure?",
                text: `Do you wish to Remove Pay Group?`,
                type: 'warning',
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: 'Yes Remove Pay Group!',
                cancelButtonText: 'Cancel!',
                customClass: {
                    confirmButton: 'swal2-confirm-custom',
                    cancelButton: 'swal2-cancel-custom',
                },
                showLoaderOnConfirm: true,
                }).then((result) => {
                if (result.value) {
                    let formData ={
                        company: companyID.value,
                        paygrp_time: [row['paygrp_time_id']]
                    }
                    axios.post(`api/v1/delete-timepolicy-paygroup/`,formData)
                    .then((response)=>{
                        if(response.data.msg == "Success"){
                            Swal.fire("Pay Group Removed succesfully!", {
                                icon: "success",
                            }); 
                            fetchPolicyGroups(policyID.value); 
                            selectedGroups.value = [];
                        }else{
                            Swal.fire({
                                title: "Error Removing Pay Group",
                                icon: "warning",
                            });
                        }                
                    })
                    .catch((error)=>{
                    console.log(error.message);
                    Swal.fire({
                        title: error.message,
                        icon: "warning",
                    });
                    })
                }else{
                    Swal.fire(`Pay Group Not Removed!`);
                }
                })
            }
        };
        const closeHolModal = () =>{
            store.dispatch('Pay_Groups/updateState', {timePolArray: []})
            holModalVisible.value = false;
            policyID.value = null;
            hideHolModalLoader();
        };
        const formFields = ref([]);
        const updateFormFields = () => {
            formFields.value = [
                { type: 'text', name: 'name',label: "Name", value: selectedPolicy.value?.name || '', required: true },
                { type: 'date', name: 'date',label: "Effective Date", value: selectedPolicy.value?.date, placeholder: "", required: true,},
                { type: 'time', name: 'weekday_time',label: "Weekday Reporting Time", value: selectedPolicy.value?.weekday_time, placeholder: "", required: true,},
                { type: 'number', name: 'weekday_hours',label: "Weekday Hrs", value: selectedPolicy.value?.weekday_hours || 0, required: true },
                { type: 'time', name: 'saturday_time',label: "Saturday Reporting Time", value: selectedPolicy.value?.saturday_time, placeholder: "", required: false,},
                { type: 'number', name: 'saturday_hours',label: "Saturday Hrs", value: selectedPolicy.value?.saturday_hours || 0, required: false },
                { type: 'time', name: 'sunday_time',label: "Sunday Reporting Time", value: selectedPolicy.value?.sunday_time, placeholder: "", required: false,},
                { type: 'number', name: 'sunday_hours',label: "Sunday Hrs", value: selectedPolicy.value?.sunday_hours || 0, required: false },
                { type: 'dropdown', name: 'overtime',label: "Overtime", value: selectedPolicy.value?.overtime || 'No', placeholder: "", required: true , options: [{ text: 'Yes', value: 'Yes' }, { text: 'No', value: 'No' }] },
                { type: 'number', name: 'break_minutes',label: "Total Break(Mins)", value: selectedPolicy.value?.break_minutes || 0, required: false },
            ];  
        };
        const handleReset = () =>{
            for(let i=0; i < formFields.value.length; i++){
                if(formFields.value[i].label == "Overtime"){
                    formFields.value[i].value = 'No';
                }else if(formFields.value[i].name == "break_minutes" || formFields.value[i].name == "weekday_hours" || formFields.value[i].name == "saturday_hours" || formFields.value[i].name == "sunday_hours"){
                    formFields.value[i].value = 0;
                }else{
                    formFields.value[i].value = '';
                }
                
            }
        }

        watch([selectedPolicy], () => {
            if (selectedPolicy.value) {
                updateFormFields();
            }else{
                updateFormFields();
            }
            
        }, { immediate: true });
        
        const showModalLoader = () =>{
            modal_loader.value = "block";
        }
        const hideModalLoader = () =>{
            modal_loader.value = "none";
        }
        const createTimePolicy = async() =>{
            showModalLoader();
            let formData = {
                name: formFields.value[0].value,
                date: formFields.value[1].value,
                weekday_time: formFields.value[2].value,
                weekday_hours: formFields.value[3].value,
                saturday_time: formFields.value[4].value || null,
                saturday_hours: formFields.value[5].value || 0,
                sunday_time: formFields.value[6].value || null,
                sunday_hours: formFields.value[7].value || 0,
                overtime: formFields.value[8].value,
                break_minutes: formFields.value[9].value,
                company: companyID.value
            }

            errors.value = [];
            for(let i=0; i < (formFields.value.length - 1); i++){
                if(formFields.value[i].value =='' && formFields.value[i].required == true){
                    errors.value.push(formFields.value[i].label);
                }
            }
            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Time_Policy/createTimePolicy', formData);
                    if (response && response.status === 201) {
                        hideModalLoader();
                        toast.success('Policy created successfully!');
                        handleReset();
                    } else {
                        toast.error('An error occurred while creating the Policy.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to create Policy: ' + error.message);
                } finally {
                    hideModalLoader();
                    searchTimePolicies();
                }
            }
        }
        const updateTimePolicy= async() =>{
            showModalLoader();
            errors.value = [];
            let formData = {
                time_policy: selectedPolicy.value.time_policy_id,
                name: formFields.value[0].value,
                date: formFields.value[1].value,
                weekday_time: formFields.value[2].value,
                weekday_hours: formFields.value[3].value,
                saturday_time: formFields.value[4].value || null,
                saturday_hours: formFields.value[5].value || 0,
                sunday_time: formFields.value[6].value || null,
                sunday_hours: formFields.value[7].value || 0,
                overtime: formFields.value[8].value,
                break_minutes: formFields.value[9].value,
                company: companyID.value
            }

            for(let i=0; i < formFields.value.length; i++){
                if(formFields.value[i].value =='' && formFields.value[i].type !='number' && formFields.value[i].required ==true){
                    errors.value.push('Error');
                }
            }
            if(errors.value.length){
                toast.error('Fill In Required Fields');
                hideModalLoader();
            }else{
                try {
                    const response = await store.dispatch('Time_Policy/updateTimePolicy', formData);
                    if (response && response.status === 200) {
                        hideModalLoader();
                        handleReset();
                        toast.success("Policy updated successfully!");              
                    } else {
                        toast.error('An error occurred while updating the Policy.');
                    }
                } catch (error) {
                    console.error(error.message);
                    toast.error('Failed to update Policy: ' + error.message);
                } finally {
                    hideModalLoader();
                    propModalVisible.value = false;
                    store.dispatch("Time_Policy/updateState",{selectedPolicy:null})
                    searchTimePolicies();
                }             
            }
        }
        const saveLeave = () =>{
            if(isEditing.value == true){
                updateTimePolicy();
            }else{
                createTimePolicy();
            }
        }
        const removePolicy = async() =>{
            if(selectedIds.value.length == 1){
                let formData = {
                    company: companyID.value,
                    time_policy: selectedIds.value
                }
                try{
                    const response = await store.dispatch('Time_Policy/deleteTimePolicy',formData)
                    if(response && response.status == 200){
                        toast.success("Policy Removed Succesfully");
                        searchTimePolicies();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Policy: ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else if(selectedIds.value.length > 1){
                toast.error("You have selected more than 1 Policy") 
            }else{
                toast.error("Please Select A Policy To Remove")
            }
        }
        const removePolicies = async() =>{
            if(selectedIds.value.length){
                let formData = {
                    company: companyID.value,
                    time_policy: selectedIds.value
                }
                try{
                    const response = await store.dispatch('Time_Policy/deleteTimePolicy',formData)
                    if(response && response.status == 200){
                        toast.success("Policy(s) Removed Succesfully");
                        searchTimePolicies();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Policy: ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                }
            }else{
                toast.error("Please Select A Policy To Remove")
            }
        }
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        }
        const searchTimePolicies = () =>{
            showLoader();
            showNextBtn.value = false;
            selectedIds.value = [];
            showPreviousBtn.value = false;
            let formData = {
                name: name_search.value,
                company_id: companyID.value,
                page_size: selectedValue.value
            } 
            axios
            .post(`api/v1/time-policies-search/?page=${currentPage.value}`,formData)
            .then((response)=>{
                policyList.value = response.data.results;
                store.commit('Time_Policy/LIST_POLICIES', policyList.value)
                propResults.value = response.data;
                propArrLen.value = policyList.value.length;
                propCount.value = propResults.value.count;
                pageCount.value = Math.ceil(propCount.value / selectedValue.value);
                if(response.data.next){
                    showNextBtn.value = true;
                }
                if(response.data.previous){
                    showPreviousBtn.value = true;
                }
            })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const selectSearchQuantity = (newValue) =>{
            selectedValue.value = newValue;
            searchTimePolicies(selectedValue.value);
        };
        const resetFilters = () =>{
            currentPage.value = 1;
            name_search.value = "";
            searchTimePolicies();
        }
        const loadPrev = () =>{
            if (currentPage.value <= 1){
                currentPage.value = 1;
            }else{
                currentPage.value -= 1;
            }
            
            searchTimePolicies();
            // scrollToTop();
        }
        const loadNext = () =>{
            if(currentPage.value >= pageCount.value){
                currentPage.value = pageCount.value;
            }else if(currentPage.value < pageCount.value){
                currentPage.value += 1;
            }
            
            searchTimePolicies();
            // scrollToTop(); 
        }
        const firstPage = ()=>{
            currentPage.value = 1;
            searchTimePolicies();
            // scrollToTop();
        }
        const lastPage = () =>{
            currentPage.value = pageCount.value;
            searchTimePolicies();
            // scrollToTop();
        }
        const addNewPolicy = () =>{
            store.dispatch("Time_Policy/updateState",{selectedPolicy:null,isEditing:false})
            propModalVisible.value = true;
            flex_basis.value = '1/3';
            flex_basis_percentage.value = '33.333';
        }
        const handleActionClick = async(rowIndex, action, row) =>{
            if( action == 'edit'){
                const policyID = row[idField];
                let formData = {
                    company: companyID.value,
                    time_policy: policyID
                }
                await store.dispatch('Time_Policy/fetchTimePolicy',formData)
                propModalVisible.value = true;
                flex_basis.value = '1/3';
                flex_basis_percentage.value = '33.333';

            }else if(action == 'delete'){
                const policyID = [row[idField]];
                let formData = {
                    company: companyID.value,
                    time_policy: policyID
                }
                await store.dispatch('Time_Policy/deleteTimePolicy',formData).
                then(()=>{
                    searchTimePolicies();
                })
            }else if( action == 'assign-pgroup'){
                store.dispatch('Pay_Groups/updateState', {timePolArray: []})
                holModalVisible.value = true;
                policyID.value = row['time_policy_id'];
                await fetchPolicyGroups(policyID.value)
            }
        }
        const dropdownOptions = ref([
            
        ]);
        const handleDynamicOption = async(option) =>{
   
        };
        const closeModal = () =>{
            propModalVisible.value = false;
            handleReset();
        }
        onBeforeMount(()=>{
            searchTimePolicies();
            fetchPayGroups();
        })
        return{
            title, searchTimePolicies,resetFilters, addButtonLabel, searchFilters, tableColumns, policyList,selectSearchQuantity,selectedValue,
            currentPage,propResults, propArrLen, propCount, pageCount, showNextBtn, showPreviousBtn,addingRight,removingRight,rightsModule,
            loadPrev, loadNext, firstPage, lastPage, idField, actions, handleActionClick, propModalVisible, closeModal,dropdownOptions,handleDynamicOption,
            submitButtonLabel, showModal, addNewPolicy, showLoader, loader, hideLoader, modal_loader, modal_top, modal_left, modal_width,displayButtons,
            showModalLoader, hideModalLoader, saveLeave, formFields, handleSelectionChange, flex_basis,flex_basis_percentage,hol_modal_loader,hol_modal_width,holModalVisible,holTitle,
            showHolModalLoader,hideHolModalLoader,closeHolModal,fetchPayGroups, handleSelectedPayGroup, clearSelectedPayGroup,payGroupArray,holComponentKey,grpColumns,grpActions,grpRows,
            dropdownWidth,pgrpIdField,selectionGroupChanged,handleGroupsActions,removePolicy, removePolicies
        }
    }
};
</script>